import File from './file.js';
export default File;
